import Storage from '@/modules/storage';

export const SET_TOKEN = 'SET_TOKEN';
export const SET_TOKEN_EXPIRY = 'SET_TOKEN_EXPIRY';
export const SET_AUTH = 'SET_AUTH';
export const SET_ME = 'SET_ME';
export const SET_FIXED_SCANNER_ID = 'SET_FIXED_SCANNER_ID';
export const SET_FIXED_SCANNER_TYPE = 'SET_FIXED_SCANNER_TYPE';
export const SET_FIXED_SESSION_KEY = 'SET_FIXED_SESSION_KEY';
export const SET_LOGIN_METHODS = 'SET_LOGIN_METHODS';
export const SET_SKIP_TUTORIAL = 'SET_SKIP_TUTORIAL';
export const SET_IS_AUTO_LEAVE = 'SET_IS_AUTO_LEAVE';
export const SET_SHADER_TYPE = 'SET_SHADER_TYPE';
export const SET_CUSTOM_SHADER = 'SET_CUSTOM_SHADER';
export const SET_CONFIRMED_LOGGED_IN = 'SET_CONFIRMED_LOGGED_IN';
export const RESET = 'RESET';

const LOGIN_METHODS = {
  CONTACTLESS: 11,
  CREATE_WITH_STORE: 12,
  SCAN_AND_CREATE: 13,
};

const getDefaultState = () => ({
  accessToken: '',
  tokenExpiryTimestamp: 0,
  me: {},
  auth: {},
  fixedScannerId: '',
  fixedScannerType: '',
  fixedSessionKey: '',
  loginMethods: [],
  confirmedLoggedIn: false,
  shaderType: 'default',
  customShader: {},
  skipTutorial: false,
  autoLeave: true,
});

const mtmUser = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    [SET_TOKEN](state, token) {
      state.accessToken = token;
    },
    [SET_TOKEN_EXPIRY](state, timestamp) {
      state.tokenExpiryTimestamp = timestamp;
    },
    [SET_AUTH](state, auth) {
      state.auth = { ...auth };
    },
    [SET_ME](state, me) {
      state.me = JSON.parse(JSON.stringify(me));
    },
    [SET_FIXED_SCANNER_ID](state, scannerId) {
      state.fixedScannerId = scannerId;
    },
    [SET_FIXED_SCANNER_TYPE](state, type) {
      state.fixedScannerType = type;
    },
    [SET_FIXED_SESSION_KEY](state, sessionKey) {
      state.fixedSessionKey = sessionKey;
    },
    [SET_LOGIN_METHODS](state, methods) {
      state.loginMethods = methods;
    },
    [SET_CONFIRMED_LOGGED_IN](state, confirmed) {
      state.confirmedLoggedIn = confirmed;
    },
    [SET_SHADER_TYPE](state, type) {
      state.shaderType = type;
    },
    [SET_CUSTOM_SHADER](state, configs) {
      state.customShader = configs;
    },
    [SET_SKIP_TUTORIAL](state, skipTutorial) {
      state.skipTutorial = skipTutorial;
    },
    [SET_IS_AUTO_LEAVE](state, autoLeave) {
      state.autoLeave = autoLeave;
    },
    [RESET](state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    getAccessToken({ state }) {
      const { accessToken, tokenExpiryTimestamp } = state;
      if (Date.now() >= tokenExpiryTimestamp) {
        return '';
      }
      return accessToken;
    },
    reset({ commit }) {
      commit(RESET);
      Storage.removeMtmUserAuth();
      Storage.removeMtmUserToken();
    },
    setConfig({ commit }, configs) {
      commit(SET_FIXED_SCANNER_ID, configs.scanner_id || '');
      commit(SET_FIXED_SCANNER_TYPE, configs.scanner_type || '');
      commit(SET_FIXED_SESSION_KEY, configs.session_key || '');
      commit(SET_LOGIN_METHODS, configs.login_methods || []);
      commit(SET_SHADER_TYPE, configs.shader_type || 'default');
      commit(SET_CUSTOM_SHADER, configs.custom_shader || {});
      commit(SET_SKIP_TUTORIAL, configs.skip_tutorial || false);
      commit(SET_IS_AUTO_LEAVE, configs.auto_leave ?? true);
    },
    setConfirmedLoggedIn({ commit }, confirmed) {
      commit(SET_CONFIRMED_LOGGED_IN, confirmed);
    },
  },
  getters: {
    isContactless: state => state.loginMethods.includes(LOGIN_METHODS.CONTACTLESS),
    canCreateWithStore: state => state.loginMethods.includes(LOGIN_METHODS.CREATE_WITH_STORE),
    canScanAndCreate: state => state.loginMethods.includes(LOGIN_METHODS.SCAN_AND_CREATE),
    isAutoLeave: state => state.autoLeave ?? true, // default: true
    isAuthenticated: state => !!state.auth.account,
    hasFixedScanner: state => !!state.fixedScannerId && !!state.fixedSessionKey,
    company: state => state.me.company || {},
    companyId: (state, getters) => getters.company.id || '',
    companyName: (state, getters) => getters.company.name || '',
    myAccount: state => state.me.account || '',
  },
};

export default mtmUser;
